import { Flex } from "@chakra-ui/react";
const Profile = () => {
  return <Flex flex="1">Profile</Flex>;
};
export default Profile;
